import type { Entitlement } from "./entitlements";

export type PlanId = string;

export interface PaypalPlanIds {
  monthly: string | null;
  yearly: string | null;
}

export interface PlanPrices {
  monthly?: { amount: string; currency: string };
  yearly?: { amount: string; currency: string };
}

export interface Plan {
  planId: PlanId;
  name: string;
  description: string;
  entitlements: Entitlement[];
  paypalPlans: PaypalPlanIds;
  prices: PlanPrices;
  active: boolean;
  sortOrder: number;
}

export const FREE_PLAN_ID: PlanId = "free";

/**
 * Plan ids the platform sells. Firestore /plans stays authoritative for prices,
 * entitlements and availability — this list only gates client-side routing and
 * admin grants, so a typo in a URL fails fast instead of round-tripping to
 * PayPal. Adding a plan here without seeding its Firestore doc changes nothing.
 */
export const PAID_PLAN_IDS = ["tvm", "tvm_tvd"] as const;

export type PaidPlanId = (typeof PAID_PLAN_IDS)[number];

export function isPaidPlanId(planId: string): planId is PaidPlanId {
  return (PAID_PLAN_IDS as readonly string[]).includes(planId);
}
